import { UnitInfoResponse, WifiInfo } from '@/types/residents/wifi';

/**
 * Extract WifiInfo from backend UnitInfoResponse supporting both hyphenated and camelCase keys.
 */
export const extractWifi = (resp: UnitInfoResponse | undefined | null): WifiInfo | null => {
  if (!resp) return null;
  // Support both structures returned by different backends
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const anyResp = resp as any;
  return anyResp['unit-info']?.wifi || anyResp.unitInfo?.wifi || null;
};

export default extractWifi;


